import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Formik, ErrorMessage } from "formik";
import { useStyles } from "./styles";
import useLend from "../../../../Hooks/lend";
import Loader from "../../../../common/Loader";
import * as yup from "yup";
import useAuthStore from "../../../../Hooks/auth";

const LendReturn = (props) => {
  const {
    addBookReturnsInfo,
    getBooksTitleInfo,
    getStudentInfo,
    bookTitle,
    studentList,
    loading,
  } = useLend();
  const classes = useStyles();
  const {institutionId}=useAuthStore()

  const lendBooksReturnSchema = yup.object().shape({
    id: yup.string().required("* Please enter the book title"),
    regNumber: yup.string().required("* Please enter the register number"),
    returnedDate: yup.string().required("* Please select the due date"),
  });
  const [addBookReturns, setAddBookReturns] = useState({
    id: "",
    regNumber: "",
    returnedDate: "",
    title: "",
  });

  useEffect(() => {
    setAddBookReturns({
      id: props.state.id,
      regNumber: props.state.regNumber,
      returnedDate: props.state.dueDate,
      title: props.state.title,
    });
  }, [props]);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Stack>
          <Box>
            <Paper
              sx={{
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
            >
              <Stack sx={{ p: 4 }}>
                <Typography sx={{ py: 2 }} className={classes.add_course_text}>
                  Book Returns
                </Typography>
                <Grid container>
                  <Grid item xl={10} sm={12}>
                    <Formik
                      enableReinitialize
                      validationSchema={lendBooksReturnSchema}
                      initialValues={addBookReturns}
                      validateOnBlur={false}
                      validateOnChange={false}
                      onSubmit={(values) => {
                        addBookReturnsInfo(values);
                      }}
                    >
                      {(formik) => {
                        const {
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          values,
                          setFieldValue,
                        } = formik;
                        return (
                          <form onSubmit={handleSubmit}>
                            <Grid
                              container
                              sx={{ py: 2 }}
                              className={classes.form_add_course}
                              spacing={3}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Book Title
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="id"
                                      name="id"
                                      placeholder="Enter title"
                                      className={
                                        errors.id && touched.id
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      onBlur={handleBlur}
                                      onChange={(e) => {
                                        handleChange(e);
                                        getBooksTitleInfo({title:e.target.value,institutionId:institutionId});
                                      }}
                                      value={values.title}
                                    />
                                    <ErrorMessage
                                      name="id"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Register Number
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      sx={{ width: 230 }}
                                      id="regNumber"
                                      name="regNumber"
                                      placeholder="Enter register number"
                                      className={
                                        errors.regNumber && touched.regNumber
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      onBlur={handleBlur}
                                      onChange={(e) => {
                                        handleChange(e);
                                        getStudentInfo(e.target.value);
                                      }}
                                      value={values.regNumber}
                                    />
                                    <ErrorMessage
                                      name="regNumber"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              sx={{ pb: 2 }}
                              className={classes.form_add_course}
                              spacing={3}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Return Date
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      sx={{ width: 245 }}
                                      id="returnedDate"
                                      type="date"
                                      name="returnedDate"
                                      value={values.returnedDate}
                                      onChange={handleChange}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />
                                    <ErrorMessage
                                      name="returnedDate"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                    ></Typography>
                                  </Stack>
                                  <Stack>
                                    <Button
                                      type="submit"
                                      sx={{
                                        px: 1,
                                        py: 1,
                                        borderRadius: "50px",
                                      }}
                                      className={classes.addLend}
                                    >
                                      Return
                                    </Button>
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                          </form>
                        );
                      }}
                    </Formik>
                  </Grid>
                </Grid>
              </Stack>
            </Paper>
          </Box>
        </Stack>
      )}
    </>
  );
};

export default LendReturn;
